module.exports = __webpack_public_path__ + "img/OBA.3b11205e.jpg";